import { render, staticRenderFns } from "./Cultura.vue?vue&type=template&id=b4fdda7c"
import script from "./Cultura.vue?vue&type=script&lang=js"
export * from "./Cultura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports